"use strict";
/* © 2016 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, July 28 , 2016
 * For information or permission request, email info@aetonixsystems.com
 */

module.exports = function (config, get, post) {
	return {
		token: {
			associate: associate,
			unassociate: unassociate,
		}
	};


	function associate(type, token){
		return post("/v2/push/token/associate", {
			type:type,
			voip_token:token
		});
	}


	function unassociate(type, token){
		return post("/v2/push/token/unassociate", {
			type:type,
			voip_token:token
		});
	}

};
